import type { State } from '../../types';

export const staffingCalendarYear = (state: State): string => state.staffingCalendarYear;
